export const SELECT_ROOMS = "SELECT_ROOMS";
export const DESELECT_ROOMS = "DESELECT_ROOMS";
export const CHECK_ROOM = "CHECK_ROOM";
export const UNCHECK_ROOM = "UNCHECK_ROOM";
export const SET_SELECTED_KEYWORD = "SET_SELECTED_KEYWORD";
export const SET_AVAILABLE_KEYWORD = "SET_AVAILABLE_KEYWORD";



// WEBPACK FOOTER //
// ./src/cleaning/schedule/roomPicker/constants.js